import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RoutePaths } from '../../constants';
import { Container } from './Container/Container';
import { MobileContainer } from './MobileContainer/MobileContainer';
import { useDevice } from 'hooks';
import { appActions } from 'store/app/slice';
import {
  selectCurrentPatientCase,
  selectPatientMessagesFilters,
  selectPatientPageFilters,
  selectPatients,
  selectShouldPatientPageUpdate,
} from 'store/patients/selectors';
import { patientsActions } from 'store/patients/slice';
import { useDispatch } from 'store/utils';

export const Patient = () => {
  const { isTablet } = useDevice();

  const dispatch = useDispatch();
  const currentPatientCase = useSelector(selectCurrentPatientCase);
  const navigate = useNavigate();
  const requestParams = useSelector(selectPatientPageFilters);
  const patientCases = useSelector(selectPatients);
  const patientMessageFilters = useSelector(selectPatientMessagesFilters);
  const shouldPatientPageUpdate = useSelector(selectShouldPatientPageUpdate);

  const params = useParams();

  const { search } = useLocation();
  const { patientId } = useParams();

  useEffect(() => {
    if (params.patientId) {
      dispatch(appActions.setShowPatientCaseList(false));
    }
  }, [dispatch]); //ignore params in dependencies for opening case from notificatons case

  useEffect(() => {
    dispatch(patientsActions.getPatientCases());
  }, [dispatch, requestParams]);

  useEffect(() => {
    if (patientCases.length && !params?.patientId && !isTablet) {
      const pathname = `${RoutePaths.PATIENTS}/${currentPatientCase?.id || patientCases[0].id}`;
      navigate(
        {
          pathname,
          search,
        },
        {
          replace: true,
        },
      );
    }
  }, [patientCases, navigate, params?.patientId, currentPatientCase?.id, isTablet, search]);

  useEffect(() => {
    if (patientId && currentPatientCase?.id !== Number(patientId)) {
      dispatch(patientsActions.getPatientCase(Number(patientId)));
    }
  }, [patientId, dispatch, currentPatientCase?.id]);

  useEffect(() => {
    const updateData = () => {
      if (document.visibilityState === 'visible' && shouldPatientPageUpdate) {
        dispatch(patientsActions.getPatientCases());
        patientId && dispatch(patientsActions.getPatientCase(Number(patientId)));

        dispatch(patientsActions.setPatientMessageFilters({}));
      }
    };

    window.addEventListener('visibilitychange', updateData);

    return () => window.removeEventListener('visibilitychange', updateData);
  }, [dispatch, patientMessageFilters, patientId, shouldPatientPageUpdate]);

  return isTablet ? <MobileContainer /> : <Container />;
};
